export default "__VITE_ASSET__C9oSxU1R__"